module.exports = {
      id: "podcast-usage",
      viewBox: "0 0 104.071 88.89",
      url: "/" + "sprite-bc0169963456b1a4ad1bb8f1c406f483.svg#podcast",
      toString: function () {
        return this.url;
      }
    }